/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TournamentMeta } from './TournamentMeta';
import {
    TournamentMetaFromJSON,
    TournamentMetaFromJSONTyped,
    TournamentMetaToJSON,
} from './TournamentMeta';

/**
 * 
 * @export
 * @interface Tournament
 */
export interface Tournament {
    /**
     * 
     * @type {string}
     * @memberof Tournament
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Tournament
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Tournament
     */
    location?: string;
    /**
     * 
     * @type {Date}
     * @memberof Tournament
     */
    date?: Date;
    /**
     * 
     * @type {TournamentMeta}
     * @memberof Tournament
     */
    meta?: TournamentMeta;
    /**
     * If true, only invited users can register for the tournament
     * @type {boolean}
     * @memberof Tournament
     */
    isInvitationOnly?: boolean;
    /**
     * List of email addresses that are allowed to register (when isInvitationOnly is true)
     * @type {Array<string>}
     * @memberof Tournament
     */
    invitedEmails?: Array<string>;
    /**
     * List of country codes that are allowed to register for this tournament. Empty array means all countries are allowed.
     * @type {Array<string>}
     * @memberof Tournament
     */
    allowedCountries?: Array<string>;
}

/**
 * Check if a given object implements the Tournament interface.
 */
export function instanceOfTournament(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TournamentFromJSON(json: any): Tournament {
    return TournamentFromJSONTyped(json, false);
}

export function TournamentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tournament {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'meta': !exists(json, 'meta') ? undefined : TournamentMetaFromJSON(json['meta']),
        'isInvitationOnly': !exists(json, 'isInvitationOnly') ? undefined : json['isInvitationOnly'],
        'invitedEmails': !exists(json, 'invitedEmails') ? undefined : json['invitedEmails'],
        'allowedCountries': !exists(json, 'allowedCountries') ? undefined : json['allowedCountries'],
    };
}

export function TournamentToJSON(value?: Tournament | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'location': value.location,
        'date': value.date === undefined ? undefined : (value.date.toISOString().substring(0,10)),
        'meta': TournamentMetaToJSON(value.meta),
        'isInvitationOnly': value.isInvitationOnly,
        'invitedEmails': value.invitedEmails,
        'allowedCountries': value.allowedCountries,
    };
}

